import { useMutation, useQueryClient } from "@tanstack/react-query"
import { fileKitKeys, useFileKit } from "./queries"

export function useAddToFavorites(options = {}) {
  const filekit = useFileKit()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async id => {
      const response = await filekit.addToFavorites(id)
      if (response.error) {
        throw new Error(response.error)
      }
      return response
    },
    ...options,
    onSuccess: async (...args) => {
      queryClient.invalidateQueries(fileKitKeys.favorites())
      queryClient.invalidateQueries(fileKitKeys.fileLists())
      await options.onSuccess?.(...args)
    }
  })
}

export function useRemoveFromFavorites(options = {}) {
  const filekit = useFileKit()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: filekit.removeFromFavorites,
    ...options,
    onSuccess: async (...args) => {
      queryClient.invalidateQueries(fileKitKeys.favorites())
      queryClient.invalidateQueries(fileKitKeys.fileLists())
      await options.onSuccess?.(...args)
    }
  })
}

export function useDeleteFile(options = {}) {
  const filekit = useFileKit()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: filekit.deleteFile,
    ...options,
    onSuccess: async (...args) => {
      queryClient.invalidateQueries(fileKitKeys.fileLists)
      await options.onSuccess?.(...args)
    }
  })
}

export function useSelectFile(options = {}) {
  const filekit = useFileKit()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: filekit.selectFile,
    ...options,
    onSuccess: async (...args) => {
      queryClient.invalidateQueries(fileKitKeys.fileLists)
      await options.onSuccess?.(...args)
    }
  })
}

export function useUpdateFile(options = {}) {
  const filekit = useFileKit()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: filekit.updateAttachment,
    ...options,
    onSuccess: async (...args) => {
      queryClient.invalidateQueries(fileKitKeys.fileLists)
      await options.onSuccess?.(...args)
    }
  })
}

export function useCreateFileDownloader(options = {}) {
  const filekit = useFileKit()
  const queryClient = useQueryClient()

  const createFile = async ({ metadata, source }) =>
    filekit.createFileFromUrl(metadata, source)

  return useMutation({
    mutationFn: createFile,
    ...options,
    onSuccess: async (...args) => {
      queryClient.invalidateQueries(fileKitKeys.fileLists())
      await options.onSuccess?.(...args)
    }
  })
}
